// @flow
import * as React from 'react';
import cn from 'classnames';
import './SelectField.scss';

import Select from 'react-select';

type Props = {
  className: string,
  options: []
};

class SelectField extends React.Component<Props> {
  static block = 'select-field';

  render() {
    const { className, options, ...rest } = this.props;
    const ns = SelectField.block;
    const computedClassName = cn(
      {
        [ns]: true
      },
      className
    );
    return (
      <div className={`${ns}__container d-flex flex-row position-relative`}>
        <Select
          className={computedClassName}
          classNamePrefix={ns}
          isSearchable={true}
          isClearable={false}
          options={options}
          {...rest}
        />
        <span className={`${ns}__icon icon-chevron__down position-absolute`} />
      </div>
    );
  }
}

export default SelectField;



// WEBPACK FOOTER //
// ./src/components/api/components/SelectField/SelectField.js